import ICTunai from 'assets/icons/currency-dollar.svg'
import ICUangBelanja from 'assets/icons/uang-belanja-wallet.png'
import ICTalangin from 'assets/icons/uang-usaha.png'
import CustomButton from 'components/Buttons/CustomButton'
import SvgIcon from 'components/Icon/SvgIcon'
import PMBProgressBarExportFile from 'components/PMBProgressBarExportFile'
import PMBSelect from 'components/PMBSelect'
import PMBTabSwitcher from 'components/PMBTabSwitcher'
import PMBSearchInputGroup from 'components/PMBSearchInputGroup'
import DropdownAddressBook from 'features/private-views/address-book/DropdownAddressBook'
import DropdownTransactionPic from './DropdownTransactionPic'
import moment from 'moment-timezone'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  ArrowRight,
  ChevronDown,
  ChevronUp,
  Download,
  Filter,
  User,
} from 'react-feather'
import { PMBDateRangePicker } from 'components/PMBNewDatePicker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Col,
  Collapse,
  Row,
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from 'reactstrap'
import { URL_LIST_TRANSACTIONS } from 'utils/pathUrl'
import {
  setFetchOption,
  setPaginationTag,
  setSelectedContact,
  setIsCustomDate,
} from '../dashboardSlice'
import { exportToExceTrx } from './downloadTransactionV2'
import useIsMobile from 'hooks/useIsMobile'
import { P } from 'components'
import PMBProjectSelections from 'components/PMBProjectSelections'
import { useLazyFetchTransactionQuery, useLazyFetchTransactionSummaryQuery } from '../dashboardApiSlice'
import { useLazyFetchSummaryCounterpartsQuery } from 'features/private-views/transaction-summary/transactionSummaryApiSlice'

export const statusOptions = [
  { value: undefined, label: 'Semua' },
  { value: 'aktif', label: 'Semua' },
  { value: 'dibatalkan', label: 'Dibatalkan' },
  { value: 'expired', label: 'Expired' },
  { value: 'diproses', label: 'Diproses oleh Penjual' },
  { value: 'menunggu approval admin', label: 'Menunggu Approval Admin' },
  { value: 'menunggu proses penjual', label: 'Menunggu Proses Penjual' },
  {
    value: 'menunggu pembayaran pembeli',
    label: 'Menunggu Pembayaran Pembeli',
  },
  {
    value: 'menunggu verifikasi penjual',
    label: 'Menunggu Verifikasi Penjual',
  },
  {
    value: 'menunggu verifikasi pembeli',
    label: 'Menunggu Verifikasi Pembeli',
  },
  {
    value: 'menunggu konfirmasi pembayaran',
    label: 'Menunggu Konfirmasi Pembayaran',
  },
  { value: 'dalam penyesuaian', label: 'Dalam Penyesuaian' },
  { value: 'selesai', label: 'Selesai' },
  { value: 'archive', label: 'Diarsipkan' },
]

// Action Buttons Component
const ActionButtons = ({
  activeFilterCount,
  handleResetFilter,
  isShowFilter,
  setIsShowFilter,
  handleExport,
  showViewMore,
  navigate,
  dispatch,
}) => (
  <div className="d-flex gap-2">
    {activeFilterCount > 0 && (
      <CustomButton
        onClick={handleResetFilter}
        color="danger"
        className="d-flex align-items-center justify-content-center"
        style={{ width: '40px', height: '40px', padding: 0, minWidth: '40px' }}
        testId="transaction-reset-filter-button"
      >
        <SvgIcon name="x" size={16} color="white" />
      </CustomButton>
    )}

    <CustomButton
      onClick={() => setIsShowFilter((prev) => !prev)}
      color="primary"
      outline
      className="flex-fill position-relative"
      testId="transaction-filter-button"
    >
      <div className="d-flex align-items-center gap-2 justify-content-center">
        <Filter size={15} />
        <P>Filter</P>
        {activeFilterCount > 0 && (
          <Badge
            color="danger"
            pill
            style={{
              position: 'absolute',
              top: '-5px',
              right: '-5px',
              fontSize: '10px',
            }}
          >
            {activeFilterCount}
          </Badge>
        )}
        {isShowFilter ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </div>
    </CustomButton>

    {/* <CustomButton
      onClick={handleExport}
      color="primary"
      outline
      className="flex-fill"
    >
      <div className="d-flex justify-content-center align-items-center gap-2">
        <Download size={15} />
        <span>Download</span>
      </div>
    </CustomButton> */}

    <UncontrolledDropdown>
      <DropdownToggle
        color="primary"
        outline
        style={{
          height: '40px',
        }}
        data-testid="transaction-download-button"
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <Download size={15} />
          <span>Download</span>
        </div>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem
          data-testid="transaction-download-menu-item-standar"
          onClick={() => {
            handleExport('Standar')
          }}
        >
          Standar
        </DropdownItem>
        <DropdownItem
          data-testid="transaction-download-menu-item-detail"
          onClick={() => {
            handleExport('Detail')
          }}
        >
          Detail
        </DropdownItem>
        <DropdownItem
          data-testid="transaction-download-menu-item-grouping"
          onClick={() => {
            handleExport('Grouping')
          }}
        >
          Grouping
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>

    {showViewMore && (
      <CustomButton
        onClick={() => {
          navigate(URL_LIST_TRANSACTIONS)
          dispatch(setFetchOption({ status: undefined, page: 0 }))
          dispatch(
            setPaginationTag({
              status: undefined,
              payment: undefined,
              trxType: undefined,
              projectId: undefined,
              selectedContact: undefined,
              searchTerm: '',
              sortby: undefined,
              sortdir: undefined,
              page: 0,
            }),
          )
        }}
        outline
        color="primary"
        className="flex-fill"
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <span>Lihat Selengkapnya</span>
          <ArrowRight size={20} />
        </div>
      </CustomButton>
    )}
  </div>
)

// Filter Section Component
const FilterSection = ({
  searchInput,
  handleSearchChange,
  handleSearchKeyPress,
  handleClearSearch,
  tag,
  handleFilter,
  tagPaginationManual,
  statusOptions,
  paymentOptions,
  rest,
  hideArchive,
  dataSellerBuyer,
  isCounterpartsLoading,
  transactionFilters,
  selectedContact,
  dispatch,
  profile,
}) => (
  <Row>
    <Col xs={12} md={3} className="mb-3">
      <PMBSearchInputGroup
        label="Cari Transaksi"
        placeholder="Cari transaksi..."
        value={searchInput}
        onChange={(e) => handleSearchChange(e.target.value)}
        onKeyPress={handleSearchKeyPress}
        maxWidth="100%"
        onClear={handleClearSearch}
        testId="transaction-search-input"
      />
    </Col>

    <Col xs={12} md="auto" lg="auto" className="mb-3">
      <PMBDateRangePicker
        data-testid="transaction-date-filter"
        style={{ width: '100%', maxWidth: '100%' }}
        value={[
          tag?.from ? moment(tag.from).format('YYYY-MM-DD') : null,
          tag?.to ? moment(tag.to).format('YYYY-MM-DD') : null,
        ]}
        onChange={(dates) => {
          if (dates && dates[0] && dates[1]) {
            const [startStr, endStr] = dates
            const start = moment(startStr).startOf('day').toDate()
            const end = moment(endStr).endOf('day').toDate()

            const prevFromStr = tag?.from
              ? moment(tag.from).startOf('day').format('YYYY-MM-DD')
              : null
            const prevToStr = tag?.to
              ? moment(tag.to).startOf('day').format('YYYY-MM-DD')
              : null

            if (prevFromStr === startStr && prevToStr === endStr) return
            handleFilter?.({ from: start, to: end })
          }
        }}
        slotProps={{
          textField: {
            size: 'small',
          },
        }}
        onClear={() => {
          dispatch(
            setPaginationTag({
              page: 0,
            }),
          )
          dispatch(
            setFetchOption({
              from: null,
              to: null,
              page: 0,
            }),
          )
          dispatch(setIsCustomDate(false))
        }}
      />
    </Col>

    <Col xs={12} md={3} className="mb-3">
      <p className="mb-2">Status</p>
      {(() => {
        const isTransaksiAktif =
          !rest?.isList ||
          rest?.title === 'Transaksi Aktif' ||
          !rest?.title

        const availableOptions = isTransaksiAktif
          ? statusOptions?.filter(
              (e) =>
                e?.value !== undefined &&
                e?.value?.toLowerCase() !== 'selesai' &&
                e?.value?.toLowerCase() !== 'dibatalkan' &&
                e?.value?.toLowerCase() !== 'expired' &&
                e?.value?.toLowerCase() !== 'archive',
            )
          : statusOptions?.filter(
              (e) =>
                e?.value?.toLowerCase() !== 'aktif' &&
                ((!hideArchive && !rest?.hideArchive) ||
                  e?.value?.toLowerCase() !== 'archive'),
            )

        const selectedValue =
          isTransaksiAktif &&
          (!tagPaginationManual?.status ||
            String(tagPaginationManual?.status).toLowerCase() === 'aktif')
            ? statusOptions[1]
            : (availableOptions?.find(
                (option) =>
                  String(option.value).toLowerCase() ===
                  String(tagPaginationManual?.status).toLowerCase(),
              ) ?? availableOptions?.[0])

        return (
          <PMBSelect
            style={{ width: '100%' }}
            testId="transaction-filter-status-select"
            options={availableOptions}
            value={selectedValue}
            onChange={(e) => handleFilter?.({ status: e?.value ?? undefined })}
          />
        )
      })()}
    </Col>

    <Col xs={12} md={3} className="mb-3">
      <p className="mb-2">Metode Pembayaran</p>
      <PMBSelect
        style={{ width: '100%' }}
        testId="transaction-filter-payment-select"
        options={paymentOptions}
        value={
          paymentOptions.find(
            (option) =>
              String(option.value) === String(tagPaginationManual?.payment),
          ) ?? paymentOptions[0]
        }
        onChange={(e) => handleFilter?.({ payment: e?.value ?? undefined })}
      />
    </Col>

    <Col xs={12} md={3} className="mb-3">
      <p className="mb-2">Tipe Transaksi</p>
      <PMBSelect
        style={{ width: '100%' }}
        testId="transaction-filter-type-select"
        options={[
          { value: undefined, label: 'Semua' },
          { value: 'manual', label: 'Transaksi Manual' },
          { value: 'system', label: 'Transaksi dari sistem' },
        ]}
        value={
          [
            { value: undefined, label: 'Semua' },
            { value: 'manual', label: 'Transaksi Manual' },
            { value: 'system', label: 'Transaksi dari sistem' },
          ].find(
            (option) =>
              String(option.value) === String(tagPaginationManual?.trxType),
          ) ?? { value: undefined, label: 'Semua' }
        }
        onChange={(e) => handleFilter?.({ trxType: e?.value ?? undefined })}
      />
    </Col>

    <Col xs={12} md={3} className="mb-3">
      <DropdownAddressBook
        data={dataSellerBuyer}
        title={tag?.type === 'BUY' ? 'Penjual' : 'Pembeli'}
        valueName={
          selectedContact
            ? {
                label:
                  selectedContact?.label ??
                  selectedContact?.partnership?.name ??
                  selectedContact?.fullName,
                value: selectedContact?.value ?? selectedContact?.userId,
              }
            : null
        }
        onSelectContact={(e) => {
          dispatch(setPaginationTag({ selectedContact: e, page: 0 }))
          dispatch(setSelectedContact(e))
        }}
        placeholderDesc={tag?.type === 'BUY' ? 'Cari Penjual' : 'Cari Pembeli'}
        isLoading={isCounterpartsLoading}
      />
    </Col>

    {!rest?.projectId && (
      <Col xs={12} md={3} className="mb-3">
        <p className="mb-2">Project</p>
        <div style={{ maxWidth: '100%' }}>
          <PMBProjectSelections
            value={
              tagPaginationManual?.projectId
                ? { value: tagPaginationManual.projectId, label: tagPaginationManual.projectName ?? `Project ${tagPaginationManual.projectId}` }
                : null
            }
            onChange={(e) =>
              handleFilter?.({
                projectId: e?.value ?? undefined,
                projectName: e?.label ?? undefined,
              })
            }
            placeholder="Semua"
          />
        </div>
      </Col>
    )}

    <Col xs={12} md={3} className="mb-3">
      <DropdownTransactionPic
        title="PIC"
        placeholderDesc="Semua"
        value={tagPaginationManual?.filterPicUserId ?? tag?.filterPicUserId}
        onChange={(opt) =>
          handleFilter?.({ filterPicUserId: opt?.value ?? undefined })
        }
        transactionFilters={transactionFilters}
        profile={profile}
      />
    </Col>
  </Row>
)

const HeaderTable = ({
  type,
  abilityBuy,
  abilitySell,
  handleFilter,
  summary,
  hideArchive,
  ...rest
}) => {
  const isArchiveHidden = Boolean(
    hideArchive || rest?.hideArchive || rest?.projectId,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isMobile = useIsMobile()
  const { tag, tagPaginationManual, selectedContact, dataTrx, profile } =
    useSelector((s) => s.dashboard)

  const [activeTab, setActiveTab] = useState(
    type || (abilityBuy ? 'BUY' : abilitySell ? 'SELL' : null),
  )
  const [isDownload, setIsDownload] = useState(false)
  const [firstRows, setFirstRows] = useState(0)
  const [totalRows, setTotalRows] = useState(0)
  const [dataSellerBuyer, setDataSellerBuyer] = useState([])
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [searchInput, setSearchInput] = useState('')

  const searchTimeoutRef = useRef()

  const [fetchTransactions] = useLazyFetchTransactionQuery()
  const [fetchTransactionSummary] = useLazyFetchTransactionSummaryQuery()
  const [fetchCounterparts, { data: counterpartsData, isLoading: isCounterpartsLoading }] =
    useLazyFetchSummaryCounterpartsQuery()

  const isBeranda =
    !rest?.isList ||
    rest?.title === 'Transaksi Aktif' ||
    !rest?.title

  const rawStatus =
    tagPaginationManual?.status !== undefined
      ? tagPaginationManual.status === 'Semua'
        ? undefined
        : tagPaginationManual.status
      : tag?.status !== undefined && tag?.status !== 'Semua'
      ? tag.status
      : undefined

  const statusParam = rawStatus
    ? String(rawStatus).toLowerCase()
    : isBeranda
    ? 'aktif'
    : undefined

  const paymentParam = tagPaginationManual?.payment
    ? String(tagPaginationManual.payment).toLowerCase()
    : undefined
  const trxTypeParam = tagPaginationManual?.trxType
    ? String(tagPaginationManual.trxType).toLowerCase()
    : undefined
  const currentTabType =
    tag?.type || type || (abilityBuy ? 'BUY' : abilitySell ? 'SELL' : 'BUY')

  const transactionFilters = useMemo(
    () => ({
      type: currentTabType,
      from: tag?.from || undefined,
      to: tag?.to || undefined,
      status: statusParam,
      payment: paymentParam,
      trxType: trxTypeParam,
      projectId: rest?.projectId || tagPaginationManual?.projectId || undefined,
      s: tagPaginationManual?.searchTerm || undefined,
    }),
    [
      currentTabType,
      tag?.from,
      tag?.to,
      statusParam,
      paymentParam,
      trxTypeParam,
      rest?.projectId,
      tagPaginationManual?.projectId,
      tagPaginationManual?.searchTerm,
    ],
  )

  const handleSearchChange = (value) => {
    setSearchInput(value)
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)

    searchTimeoutRef.current = setTimeout(() => {
      dispatch(setPaginationTag({ searchTerm: value.trim(), page: 0 }))
    }, 600)
  }

  const handleClearSearch = () => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
    setSearchInput('')
    dispatch(setPaginationTag({ searchTerm: '', page: 0 }))
  }

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
      dispatch(setPaginationTag({ searchTerm: searchInput.trim(), page: 0 }))
    }
  }

  const handleExport = async (exportType = 'Standar') => {
    setIsDownload(true)
    setFirstRows(0)

    let itemsToExport = []
    let exportSummary = summary

    let pageNum = 0
    const pageSize = 50
    let fetchedItems = []

    const isBeranda =
      !rest?.isList ||
      rest?.title === 'Transaksi Aktif' ||
      !rest?.title

    const rawStatus =
      tagPaginationManual?.status !== undefined
        ? tagPaginationManual.status === 'Semua'
          ? undefined
          : tagPaginationManual.status
        : tag?.status !== undefined && tag?.status !== 'Semua'
        ? tag.status
        : undefined

    const rawStatusParam = rawStatus
      ? String(rawStatus).toLowerCase()
      : isBeranda
      ? 'aktif'
      : undefined
    const statusParam =
      isArchiveHidden && rawStatusParam === 'archive'
        ? undefined
        : rawStatusParam

    const contactUserId =
      tagPaginationManual?.selectedContact?.userId ??
      tagPaginationManual?.selectedContact?.value ??
      selectedContact?.userId ??
      selectedContact?.value

    const picUserId =
      tagPaginationManual?.filterPicUserId !== undefined
        ? tagPaginationManual.filterPicUserId
        : tag?.filterPicUserId

    const paymentParam = tagPaginationManual?.payment
      ? String(tagPaginationManual.payment).toLowerCase()
      : undefined
    const trxTypeParam = tagPaginationManual?.trxType
      ? String(tagPaginationManual.trxType).toLowerCase()
      : undefined

    const filtertypeParam =
      (tag?.type || type || 'BUY') === 'SELL' ? 'buyid' : 'sellerid'

    const payload = {
      type: tag?.type || type || 'BUY',
      page: pageNum,
      size: pageSize,
      allitem: 1,
      s: tagPaginationManual?.searchTerm || undefined,
      status: statusParam,
      payment: paymentParam,
      trxType: trxTypeParam,
      projectId: rest?.projectId || tagPaginationManual?.projectId || undefined,
      filterPicUserId: picUserId !== undefined ? picUserId : undefined,
      filtertype: contactUserId ? filtertypeParam : undefined,
      filtertypevalue: contactUserId ? contactUserId : undefined,
      from: tag?.from || undefined,
      to: tag?.to || undefined,
      sortby: tagPaginationManual?.sortby || 'createdAt',
      sortdir: tagPaginationManual?.sortdir || 'desc',
    }

    const [firstResponse, summaryResponse] = await Promise.all([
      fetchTransactions(payload),
      fetchTransactionSummary(payload),
    ])
    const firstData = firstResponse?.data
    const summaryData = summaryResponse?.data

    if (summaryData) {
      exportSummary = summaryData
    }

    if (firstData) {
      fetchedItems = [...(firstData.items || [])]
      const totalItemsCount = firstData.totalItems || 0

      if (totalItemsCount > pageSize) {
        const totalPages = Math.ceil(totalItemsCount / pageSize)
        const promises = []
        for (let p = 1; p < totalPages; p++) {
          promises.push(fetchTransactions({ ...payload, page: p }))
        }
        const results = await Promise.all(promises)
        results.forEach((res) => {
          const nextData = res?.data
          if (nextData && nextData.items) {
            fetchedItems = [...fetchedItems, ...nextData.items]
          }
        })
      }
    }

    setTotalRows(fetchedItems.length)

    if (exportType === 'Grouping') {
      fetchedItems = fetchedItems.map((transaction) => {
        const grouped = {}
        const itemDetails = Array.isArray(transaction?.itemDetail)
          ? transaction.itemDetail
          : []

        itemDetails.forEach((item) => {
          const unitValue = item?.unit?.value ?? item?.unit ?? '-'
          const commodityId =
            item?.itemId ?? item?.id ?? item?.inventoryId ?? item?.nameItem
          const key = `${commodityId}_${unitValue}`

          if (!grouped[key]) {
            grouped[key] = {
              ...item,
              unit: unitValue,
              amount: 0,
              totalPrice: 0,
              prices: [],
            }
          }

          grouped[key].amount += Number(item?.amount ?? 0)
          grouped[key].totalPrice += Number(
            item?.totalPrice ??
              Number(item?.amount ?? 0) * Number(item?.price ?? 0),
          )
          grouped[key].prices.push(Number(item?.price ?? 0))
        })

        const groupedItems = Object.values(grouped).map((item) => ({
          ...item,
          isDifferentPrices: new Set(item.prices).size > 1,
        }))

        return {
          ...transaction,
          itemDetail: groupedItems,
        }
      })
    }
    itemsToExport = fetchedItems

    await exportToExceTrx(
      itemsToExport,
      rest?.columns,
      exportSummary,
      `Transaksi_${exportType}`,
      ({ fetched }) => setFirstRows(fetched),
      rest?.data?.items?.length === rest?.allItems?.items?.length
        ? dataTrx
        : null,
      exportType,
    )

    setTimeout(() => setIsDownload(false), 2000)
  }

  const paymentOptions = useMemo(
    () => [
      { value: undefined, label: 'Semua' },
      ...(tag?.type === 'SELL'
        ? [
            {
              value: 'non-tunai',
              label: (
                <div className="d-flex align-items-center gap-2">
                  <img
                    width={20}
                    height={20}
                    src={ICUangBelanja}
                    alt="Non Tunai"
                  />{' '}
                  Non Tunai
                </div>
              ),
            },
          ]
        : [
            {
              value: 'direct',
              label: (
                <div className="d-flex align-items-center gap-2">
                  <img
                    width={20}
                    height={20}
                    src={ICUangBelanja}
                    alt="Uang Belanja"
                  />{' '}
                  Uang Belanja
                </div>
              ),
            },
            {
              value: 'talangan',
              label: (
                <div className="d-flex align-items-center gap-2">
                  <img width={20} height={20} src={ICTalangin} alt="Talangin" />{' '}
                  Talangin
                </div>
              ),
            },
          ]),
      {
        value: 'agent',
        label: (
          <div className="d-flex align-items-center gap-2">
            <SvgIcon name="user-check-converted" size={22} color="#006386" />{' '}
            Pembayaran Melalui Agen
          </div>
        ),
      },
      {
        value: 'tunai',
        label: (
          <div className="d-flex align-items-center gap-2">
            <SvgIcon name="old-icons-money-bill" size={22} color="#006386" />{' '}
            Tunai
          </div>
        ),
      },
      {
        value: 'sellerscredit',
        label: (
          <div className="d-flex align-items-center gap-2">
            <SvgIcon name="database" size={22} color="#006386" /> Kredit Penjual
          </div>
        ),
      },
      {
        value: 'cod',
        label: (
          <div className="d-flex align-items-center gap-2">
            <SvgIcon
              name="old-icons-hand-holding-usd"
              size={16}
              color="white"
              withBackground={true}
              backgroundColor="#7F56D9"
            />{' '}
            COD
          </div>
        ),
      },
    ],
    [tag?.type],
  )

  const handleTabChange = (tabKey) => {
    let newPayment = tagPaginationManual?.payment
    if (
      tabKey === 'SELL' &&
      (newPayment === 'talangan' || newPayment === 'direct')
    ) {
      newPayment = 'non-tunai'
    } else if (tabKey === 'BUY' && newPayment === 'non-tunai') {
      newPayment = undefined
    }

    setActiveTab(tabKey)
    // Reset selectedContact saat switch tab
    dispatch(
      setPaginationTag({
        payment: newPayment,
        selectedContact: undefined,
        sortby: undefined,
        sortdir: undefined,
        page: 0,
      }),
    )
    dispatch(setSelectedContact(undefined))
    dispatch(setFetchOption({ page: 0, type: tabKey }))
  }

  const tabs = [
    { key: 'BUY', label: 'Pembelian' },
    { key: 'SELL', label: 'Penjualan' },
  ].filter(
    (tab) =>
      (tab.key === 'BUY' && abilityBuy) || (tab.key === 'SELL' && abilitySell),
  )

  const activeFilterCount = useMemo(() => {
    let count = 0
    if (tagPaginationManual?.status) count++
    if (tagPaginationManual?.payment) count++
    if (tagPaginationManual?.trxType) count++
    if (!rest?.projectId && tagPaginationManual?.projectId !== undefined) count++
    if (tag?.from && tag?.to) count++
    // Check selectedContact dari tagPaginationManual atau state
    if (tagPaginationManual?.selectedContact || selectedContact) count++
    if (searchInput) count++
    if (
      (tagPaginationManual?.filterPicUserId ?? tag?.filterPicUserId) !==
      undefined
    )
      count++
    return count
  }, [
    tagPaginationManual,
    tag?.from,
    tag?.to,
    tag?.filterPicUserId,
    selectedContact,
    searchInput,
    rest?.projectId,
  ])

  const handleResetFilter = () => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
    setSearchInput('')

    dispatch(
      setPaginationTag({
        status: undefined,
        payment: undefined,
        trxType: undefined,
        projectId: rest?.projectId || undefined,
        selectedContact: undefined,
        filterPicUserId: undefined,
        searchTerm: '',
        sortby: undefined,
        sortdir: undefined,
        page: 0,
      }),
    )
    dispatch(
      setFetchOption({
        status: undefined,
        payment: undefined,
        projectId: rest?.projectId || undefined,
        filterPicUserId: undefined,
        from: undefined,
        to: undefined,
        page: 0,
      }),
    )
    dispatch(setSelectedContact(null))
    dispatch(setIsCustomDate(false))
  }

  useEffect(() => {
    if (!type) {
      dispatch(
        setFetchOption({
          type: abilityBuy ? 'BUY' : abilitySell ? 'SELL' : '',
        }),
      )
    }
  }, [type, abilityBuy, abilitySell, dispatch])

  useEffect(() => {
    const params = {
      size: 200,
      sortby: 'name',
      sortdir: 'ASC',
    }
    if (tag?.from) {
      params.startDate = moment(tag.from).startOf('day').toISOString()
    }
    if (tag?.to) {
      params.endDate = moment(tag.to).endOf('day').toISOString()
    }
    fetchCounterparts(params)
  }, [tag?.from, tag?.to, fetchCounterparts])

  useEffect(() => {
    if (!counterpartsData?.items) {
      setDataSellerBuyer([])
      return
    }

    const mappedData = counterpartsData.items.map((c) => ({
      ...c,
      userId: c.id,
      relationUserId: c.id,
      value: c.id,
      label: c.name,
      fullName: c.name,
      phoneNumber: c.phoneNumber,
      sides: c.sides,
    }))

    setDataSellerBuyer(mappedData)
  }, [counterpartsData])

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current)
    }
  }, [])

  useEffect(() => {
    const searchTerm = tagPaginationManual?.searchTerm ?? ''
    if (String(searchInput) !== String(searchTerm)) {
      setSearchInput(searchTerm)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagPaginationManual?.searchTerm])

  useEffect(() => {
    const newType =
      tag?.type || type || (abilityBuy ? 'BUY' : abilitySell ? 'SELL' : null)
    if (newType && newType !== activeTab) setActiveTab(newType)
  }, [tag?.type, type, abilityBuy, abilitySell, activeTab])

  useEffect(() => {
    if (activeFilterCount > 0) setIsShowFilter(true)
  }, [activeFilterCount])

  return (
    <div className="w-100">
      <PMBProgressBarExportFile
        isDialogShow={isDownload}
        firstRows={firstRows}
        totalRows={totalRows}
        onCancel={() => setIsDownload(false)}
      />

      {tabs.length > 0 && (
        <>
          <div className="mb-2 d-flex justify-content-between align-items-center flex-wrap">
            <PMBTabSwitcher
              activeTab={activeTab}
              tabs={tabs}
              onTabChange={handleTabChange}
              testId="transaction-tab"
            />

            {!isMobile && (
              <ActionButtons
                activeFilterCount={activeFilterCount}
                handleResetFilter={handleResetFilter}
                isShowFilter={isShowFilter}
                setIsShowFilter={setIsShowFilter}
                handleExport={handleExport}
                showViewMore={!rest?.title}
                navigate={navigate}
                dispatch={dispatch}
              />
            )}
          </div>

          {rest?.isList && !isArchiveHidden && (
            <div className="mb-2">
              <PMBTabSwitcher
                variant="pills"
                activeTab={statusParam === 'archive' ? 'archive' : 'all'}
                tabs={[
                  { key: 'all', label: 'Semua Transaksi' },
                  { key: 'archive', label: 'Diarsipkan' },
                ]}
                onTabChange={(key) => {
                  if (key === 'archive') {
                    handleFilter?.({ status: 'archive' })
                  } else {
                    handleFilter?.({ status: undefined })
                  }
                }}
                testId="transaction-archive-subtab"
              />
            </div>
          )}

          {isMobile && (
            <div className="mb-3">
              <div className="d-flex gap-2 mb-2">
                {/* <CustomButton
                  onClick={handleExport}
                  color="primary"
                  outline
                  className="flex-fill"
                >
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    <Download size={15} />
                    <span>Download</span>
                  </div>
                </CustomButton> */}

                <div className="d-flex gap-2 flex-fill">
                  {activeFilterCount > 0 && (
                    <CustomButton
                      onClick={handleResetFilter}
                      color="danger"
                      className="d-flex align-items-center justify-content-center"
                      style={{
                        width: '40px',
                        height: '40px',
                        padding: 0,
                        minWidth: '40px',
                      }}
                      testId="transaction-reset-filter-button"
                    >
                      <SvgIcon name="x" size={16} color="white" />
                    </CustomButton>
                  )}
                  <CustomButton
                    onClick={() => setIsShowFilter((prev) => !prev)}
                    color="primary"
                    outline
                    className="flex-fill position-relative"
                    testId="transaction-filter-button"
                  >
                    <div className="d-flex align-items-center gap-2 justify-content-center text-nowrap">
                      <Filter size={15} />
                      <P>Filter</P>
                      {activeFilterCount > 0 && (
                        <Badge
                          color="danger"
                          pill
                          style={{
                            position: 'absolute',
                            top: '-5px',
                            right: '-5px',
                            fontSize: '10px',
                          }}
                        >
                          {activeFilterCount}
                        </Badge>
                      )}
                      {isShowFilter ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      )}
                    </div>
                  </CustomButton>
                </div>

                <UncontrolledDropdown className="flex-fill">
                  <DropdownToggle
                    color="primary"
                    outline
                    className="w-100"
                    style={{
                      height: '40px',
                    }}
                    data-testid="transaction-download-button"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <Download size={15} />
                      <span>Download</span>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem
                      data-testid="transaction-download-menu-item-standar"
                      onClick={() => handleExport('Standar')}
                    >
                      Standar
                    </DropdownItem>
                    <DropdownItem
                      data-testid="transaction-download-menu-item-detail"
                      onClick={() => handleExport('Detail')}
                    >
                      Detail
                    </DropdownItem>
                    <DropdownItem
                      data-testid="transaction-download-menu-item-grouping"
                      onClick={() => handleExport('Grouping')}
                    >
                      Grouping
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>

              {!rest?.title && (
                <CustomButton
                  onClick={() => {
                    navigate(URL_LIST_TRANSACTIONS)
                    dispatch(setFetchOption({ status: undefined, page: 0 }))
                    dispatch(
                      setPaginationTag({
                        status: undefined,
                        payment: undefined,
                        trxType: undefined,
                        projectId: undefined,
                        selectedContact: undefined,
                        searchTerm: '',
                        sortby: undefined,
                        sortdir: undefined,
                        page: 0,
                      }),
                    )
                  }}
                  outline
                  color="primary"
                  className="w-100"
                >
                  <div className="d-flex justify-content-center align-items-center gap-2 text-nowrap">
                    <span>Lihat Selengkapnya</span>
                    <ArrowRight size={20} />
                  </div>
                </CustomButton>
              )}
            </div>
          )}
        </>
      )}

      <Collapse isOpen={isShowFilter}>
        <div className="border rounded p-3 bg-light mb-3">
          <FilterSection
            searchInput={searchInput}
            handleSearchChange={handleSearchChange}
            handleSearchKeyPress={handleSearchKeyPress}
            handleClearSearch={handleClearSearch}
            tag={tag}
            handleFilter={handleFilter}
            tagPaginationManual={tagPaginationManual}
            statusOptions={statusOptions}
            paymentOptions={paymentOptions}
            rest={rest}
            hideArchive={isArchiveHidden}
            dataSellerBuyer={dataSellerBuyer}
            isCounterpartsLoading={isCounterpartsLoading}
            transactionFilters={transactionFilters}
            selectedContact={selectedContact}
            dispatch={dispatch}
            profile={profile}
          />
        </div>
      </Collapse>
    </div>
  )
}

export default HeaderTable
